import React from "react";

const sections = [
  {
    title: "🎒 School Students",
    items: [
      "Time required to complete homework",
      "Time required to revise one chapter before exam",
      "Time to prepare for a science project",
      "Time required to travel from home to school",
      "Number of days required to finish a library book",
      "Time needed to prepare for a school competition",
      "Time required to complete a math practice worksheet",
      "Time required to memorize a poem",
      "Time required to complete a drawing or craft assignment",
      "Time needed to practice a musical instrument"
    ]
  },
  {
    title: "🎓 Senior Students (Class 9–College)",
    items: [
      "Time required to prepare for a semester exam",
      "Time needed to complete a coding assignment",
      "Duration to finish a college project report",
      "Time required to prepare a presentation",
      "Time to learn a new software tool",
      "Time required to prepare for an interview",
      "Duration required to complete internship tasks",
      "Time to write a research paper",
      "Time required to prepare for competitive exams",
      "Time required to complete an online certification course"
    ]
  },
  {
    title: "💼 Professionals",
    items: [
      "Software feature development time",
      "Time required to fix a production bug",
      "Duration for preparing a project proposal",
      "Time needed to complete a client report",
      "Effort required for data analysis",
      "Time required to conduct employee training",
      "Duration for recruitment hiring cycle",
      "Time required for product design iteration",
      "Duration to complete a marketing campaign",
      "Time required for IT system migration"
    ]
  },
  {
    title: "🏠 Home / Personal Life",
    items: [
      "Time required to cook dinner",
      "Time required to clean the house",
      "Time required to finish grocery shopping",
      "Time needed to repair a household appliance",
      "Time needed to organize a family event",
      "Time required to pack luggage for travel",
      "Time required to complete laundry",
      "Time required to assemble new furniture",
      "Time required to prepare festival decorations",
      "Time required to host guests"
    ]
  },
  {
    title: "🏭 MSME Businesses",
    items: [
      "Time required to manufacture a batch of products",
      "Time needed to complete a customer order",
      "Time required for machine maintenance",
      "Time required to onboard a new employee",
      "Time needed to procure raw materials",
      "Duration required for quality inspection",
      "Time required to deliver goods to a customer",
      "Time required to launch a new product",
      "Time needed to implement a new ERP system",
      "Time required to resolve customer complaints"
    ]
  },
  {
    title: "👩 Women / Housewives",
    items: [
      "Time required to cook breakfast for family",
      "Time required to prepare festival sweets",
      "Time required to finish household cleaning",
      "Time required for children's school preparation",
      "Time required to organize family gatherings",
      "Time required to shop in a local market",
      "Time required to prepare weekly meal plans",
      "Time required to manage household finances",
      "Time required to prepare pickles or preserves",
      "Time required to decorate home for festivals"
    ]
  },
  {
    title: "🏛 Government / Public Administration",
    items: [
      "Time required to complete a road construction project",
      "Time required to issue government permits",
      "Time required to implement digital services",
      "Time required to conduct public surveys",
      "Time required to deliver welfare benefits",
      "Time required to complete irrigation projects",
      "Time required to construct public schools",
      "Time required for disaster response operations",
      "Time required to digitize government records",
      "Time required to complete a public housing project"
    ]
  },
  {
    title: "🌾 Agriculture / Farmers",
    items: [
      "Time required for crop sowing",
      "Time required for crop harvesting",
      "Time required for irrigation cycles",
      "Time required for fertilizer application",
      "Time required to prepare land for cultivation",
      "Time required to transport produce to market",
      "Time required to install irrigation systems",
      "Time required for crop pest control",
      "Time required to build farm storage structures",
      "Time required for dairy production activities"
    ]
  },
  {
    title: "🏭 Manufacturing",
    items: [
      "Time required to set up a machine for a new product batch",
      "Time required to manufacture 100 units of a component",
      "Time needed for machine preventive maintenance",
      "Time required to complete product quality inspection",
      "Time required to change tooling or dies",
      "Time required to assemble a finished product",
      "Time required to package finished goods",
      "Time required to repair a machine breakdown",
      "Time required to train a new machine operator",
      "Time required to complete a customer production order"
    ]
  },
  {
    title: "🏥 Health Services",
    items: [
      "Time required to complete patient registration",
      "Time required for doctor consultation",
      "Time required to perform a medical test",
      "Time required to prepare operation theatre for surgery",
      "Time required to discharge a patient",
      "Time required for ambulance to reach patient",
      "Time required to process insurance claims",
      "Time required to sterilize medical equipment",
      "Time required for nurse shift handover",
      "Time required to complete hospital billing"
    ]
  },
  {
    title: "🚚 Transportation / Logistics",
    items: [
      "Time required to deliver goods to a customer",
      "Time required to load a truck at warehouse",
      "Time required to unload cargo",
      "Time required to complete vehicle maintenance",
      "Time required for driver route travel in city traffic",
      "Time required to clear goods at logistics hub",
      "Time required for customs clearance",
      "Time required to complete daily delivery routes",
      "Time required for fuel refilling and vehicle check",
      "Time required to dispatch goods from warehouse"
    ]
  },
  {
    title: "🍽 Restaurants / Food Business",
    items: [
      "Time required to prepare a customer order",
      "Time required to cook a specific dish",
      "Time required to serve food to customers",
      "Time required to clean kitchen after service",
      "Time required to prepare ingredients",
      "Time required to complete restaurant billing",
      "Time required to deliver online food orders",
      "Time required to restock kitchen supplies",
      "Time required to train new kitchen staff",
      "Time required to prepare buffet service"
    ]
  },
  {
    title: "🗂 Office / Assistant Work",
    items: [
      "Time required to prepare meeting minutes",
      "Time required to schedule appointments",
      "Time required to organize office documents",
      "Time required to prepare a presentation deck",
      "Time required to send official emails",
      "Time required to prepare monthly reports",
      "Time required to arrange travel bookings",
      "Time required to coordinate meetings",
      "Time required to organize digital files",
      "Time required to process expense claims"
    ]
  },
  {
    title: "👷 Labour / Skilled Workers",
    items: [
      "Time required to paint a room",
      "Time required to lay floor tiles",
      "Time required to repair plumbing leaks",
      "Time required to construct a brick wall",
      "Time required to install electrical wiring",
      "Time required to dig foundation",
      "Time required to load materials onto trucks",
      "Time required to assemble furniture",
      "Time required to complete welding work",
      "Time required to install doors and windows"
    ]
  }
];

const ThreePUsage = () => {
  return (
    <div className="bg-black text-white min-h-screen p-4">

      <div className="mx-auto">

        <h1 className="text-lg lg:text-xl font-bold text-yellow-200 mb-2">
          🧠 Three-Point Estimation Example Usage
        </h1>

        <h1 className="text-xs lg:text-sm text-gray-300 mb-6">
          Practical real-life examples where Three-Point Estimation helps in
          planning, productivity and decision making.
        </h1>

        {sections.map((section, index) => (
          <div key={index} className="mb-8">

            <h2 className="text-sm lg:text-xl font-semibold text-purple-300 mb-3">
              {section.title}
            </h2>

            <ul className="list-disc list-inside text-xs lg:text-base space-y-1 text-gray-200">
              {section.items.map((item, i) => (
                <li className="text-gray-100" key={i}>{item}</li>
              ))}
            </ul>

          </div>
        ))}

      </div>
    </div>
  );
};

export default ThreePUsage;